import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { TargetType } from '../../../enums/eInvoicing'
import { QueryKeys } from '../../../enums/queryKeys'
import { PDP_NETWORK_TYPE } from '../constants'
import { getReasons } from '../query-api'

interface UseGetEInvoiceLifecycleReasons {
  lifecycleAction: string
  eInvoiceId: string | undefined
}

export const useGetEInvoicingLifecycleReasons = ({ lifecycleAction, eInvoiceId }: UseGetEInvoiceLifecycleReasons) => {
  const { organization } = useUserOrganization()

  const organizationId = organization?.id ?? ''
  const targetType = TargetType.BILLY

  const { data, isLoading } = useQuery(
    [QueryKeys.EInvoicingLifecycleReasons, PDP_NETWORK_TYPE, organizationId, lifecycleAction],
    () =>
      getReasons({
        network: PDP_NETWORK_TYPE,
        targetId: organizationId,
        eInvoiceId: eInvoiceId ?? '',
        lifecycleAction,
        targetType,
      }),
    {
      enabled: !!organizationId && !!eInvoiceId,
    },
  )

  return {
    data: data?.data,
    isProcessing: isLoading,
  }
}
